var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"menu"}},[_c('Menu',{attrs:{"textColor":'#666666',"uniqueOpened":true,"defaultActive":"true"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }